import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { SelectList } from '@abyss/ui/form/SelectList';
import { useForm } from '@abyss/ui/form/hooks/useForm';
import { styled } from '@abyss/ui/tools/styled';

const CustomLabel = styled.label({
  fontSize: ({ theme }) => theme.fontSizes.size400,
  color: ({ theme }) => theme.colors.UHC_GRAY_DARK,
  fontWeight: 600,
});

export const TaxIdNumbers = ({
  uuid,
  selectedProvider,
  setSelectedProvider,
  allowProviderSearch,
  getOrganizations,
  organizations,
}) => {
  const form = useForm();
  const { organizationId, corporateProviderMpin, uniqueId } = selectedProvider;

  useEffect(() => {
    if (allowProviderSearch) {
      if (corporateProviderMpin) {
        getOrganizations({
          variables: JSON.stringify({
            corpMpin: selectedProvider.corporateProviderMpin,
            id: selectedProvider.uhcOrgId,
            uhcProviderId: selectedProvider.uhcProviderId,
          }),
        });
      } else {
        form.reset('utility.taxIdNumber');
      }
    }
  }, [uuid, uniqueId, allowProviderSearch]);

  const handleChange = selectedTaxId => {
    const taxIdNumber = selectedTaxId ? selectedTaxId.tin : null;
    if (selectedProvider.taxIdNumber !== taxIdNumber) {
      const newData = {
        ...selectedProvider,
        organizationId,
        corporateProviderMpin,
        taxIdNumber,
        uniqueId: selectedProvider.uniqueId,
      };
      setSelectedProvider(newData);
      form.reset('utility.servicingProvider');
    }
  };

  return (
    <React.Fragment>
      <CustomLabel
        id="tax-id-header"
        data-testid="tax-id-header"
        htmlFor="provider-select-taxidnumbers"
      >
        Tax ID Number
      </CustomLabel>
      <SelectList
        id="provider-select-taxidnumbers"
        data-testid="provider-select-taxidnumbers"
        data-cy="provider-select-taxidnumbers"
        model="utility.taxIdNumber"
        aria-label="change tax ID number"
        aria-labelledby="tax-id-header"
        aria-required="true"
        options={organizations || []}
        placeholder="Select Tax ID Number..."
        labelKey="tin"
        valueKey="tin"
        isDisabled={!corporateProviderMpin}
        onChange={handleChange}
        validators={{ required: value => !value }}
      />
    </React.Fragment>
  );
};

TaxIdNumbers.propTypes = {
  uuid: PropTypes.string.isRequired,
  selectedProvider: PropTypes.shape({
    organizationId: PropTypes.string,
    corporateProviderMpin: PropTypes.string,
    taxIdNumber: PropTypes.string,
    uhcOrgId: PropTypes.string,
    uhcProviderId: PropTypes.string,
    uniqueId: PropTypes.string,
  }),
  setSelectedProvider: PropTypes.func.isRequired,
  allowProviderSearch: PropTypes.bool,
  getOrganizations: PropTypes.func,
  organizations: PropTypes.arrayOf(PropTypes.shape({})),
};

TaxIdNumbers.defaultProps = {
  selectedProvider: null,
  allowProviderSearch: true,
  getOrganizations: () => null,
  organizations: null,
};
